<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-row>
        <el-col :span="24" class="form-line">
          <el-form size="small" :inline="true">
            <el-form-item label="菜单名称">
              <el-input v-model="filterText" placeholder="请输入菜单名称"></el-input>
            </el-form-item>
            <div style="float: right">
              <el-form-item>
                <el-button-group>
                  <el-button type="primary" @click="handleAdd(null)">新增</el-button>
                </el-button-group>
              </el-form-item>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="custom-tree-container">
            <div class="block">
              <el-tree
                :data="menuData"
                node-key="id"
                default-expand-all
                :filter-node-method="filterNode"
                :expand-on-click-node="false"
                :props="treeProps"
                ref="tree">
                <template #default="{ node, data }">
                  <span class="custom-tree-node">
                    <span>{{ node.label }}</span>
                    <span>
                      <span style="padding-right: 10px">
                        <el-link type="primary" :underline="false" @click="handleAdd(node)">新增子菜单</el-link>
                      </span>
                      <span style="padding-right: 10px">
                        <el-link type="primary" :underline="false" @click="edit(node)">编辑</el-link>
                      </span>
                      <span>
                        <el-link type="primary" :underline="false" @click="handleDel(data)">删除</el-link>
                      </span>
                    </span>
                  </span>
                </template>
              </el-tree>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <el-form label-width="80px" size="small" :model="editForm" :rules="editFormRules" ref="editForm">
              <el-form-item label="父级菜单">
                <el-input v-model="editForm.parentName" :readonly="true"></el-input>
              </el-form-item>
              <el-form-item label="菜单名称" prop="menuName">
                <el-input v-model="editForm.menuName" maxlength="30" placeholder="请输入菜单名称"></el-input>
              </el-form-item>
              <el-form-item label="菜单图标">
                <el-input v-model="editForm.icon" maxlength="50" placeholder="请输入菜单图标"></el-input>
              </el-form-item>
              <el-form-item label="菜单路径">
                <el-input v-model="editForm.path" maxlength="50" placeholder="请输入菜单路径"></el-input>
              </el-form-item>
              <el-form-item label="菜单组件">
                <el-input v-model="editForm.component" maxlength="100" placeholder="请输入菜单组件"></el-input>
              </el-form-item>
              <el-form-item label="菜单排序" prop="sort">
                <el-input v-model="editForm.sort" placeholder="请输入菜单排序" type="number"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-button style="float: right" size="small" type="primary" @click="addSubmit">确认</el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </el-col>
      </el-row>

    </section>
  </el-card>
</template>

<script>

import { doPost } from '../../api/api'

let id = 1000
export default {
  data () {
    var validateAmount = (rule, value, callback) => {
      if (!value) {
        return callback()
      } else if (!(/(^[1-9]\d*$)/.test(value)) || value > this.depositAmount) {
        return callback(new Error(`请输入1-${this.depositAmount}范围的正整数`))
      } else {
        return callback()
      }
    }
    return {
      treeProps: { label: 'menuName', children: 'sonList' },
      menuData: [],
      filterText: '',
      depositAmount: 9999,
      editForm: {
        systemFlag: 'service-mdinfo',
        menuOrder: 1,
        showFlag: 1,
        parentName: '',
        parentId: ''
      },
      filters: {
        systemFlag: 'service-mdinfo',
        realName: ''
      },
      listLoading: false,
      editFormRules: {
        menuName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        sort: [
          { validator: validateAmount, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    append (data) {
      const newChild = { id: id++, label: 'testtest', children: [] }
      if (!data.children) {
        data.children = []
      }
      data.children.push(newChild)
      this.data = [...this.data]
    },

    edit (data) {
      console.log(data)
      this.editForm = data.data
      this.editForm.parentName = data.parent.data.menuName
    },

    remove (node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.id === data.id)
      children.splice(index, 1)
      this.data = [...this.data]
    },
    filterNode (value, data) {
      if (!value) return true
      return data.menuName.indexOf(value) !== -1
    },
    // 获取菜单树形结构
    getMenuList () {
      this.listLoading = true
      doPost('/sysMenu/getSysMenuTree', this.filters).then((res) => {
        console.log(res.result)
        this.menuData = res.result
        this.listLoading = false
      })
    },
    // 删除
    handleDel: function (data) {
      console.log(data)
      this.$confirm('确认删除' + data.menuName + '吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        var para = { id: data.id }
        doPost('/sysMenu/delete', para).then((res) => {
          this.listLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getMenuList()
        })
      }).catch(() => {

      })
    },
    // 显示新增界面
    handleAdd: function (data) {
      // 初始化editForm
      this.editForm = {
        systemFlag: 'service-mdinfo',
        menuOrder: 1,
        showFlag: 1
      }
      if (data != null) {
        this.editForm.menuOrder = data.data.menuOrder + 1
        this.editForm.parentId = data.data.id
        this.editForm.parentName = data.data.menuName
      }
      console.log(this.editForm)
    },
    // 新增
    addSubmit: function () {
      console.log(this.editForm)
      delete this.editForm.sonList
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.listLoading = true
            doPost('/sysMenu/saveOrUpdate', this.editForm).then((res) => {
              console.log(res.result)
              this.editForm.id = res.result.id
              this.$message({
                message: '更新成功',
                type: 'success'
              })
              this.getMenuList()
              this.listLoading = false
            })
          })
        }
      })
    }
  },
  mounted () {
    this.getMenuList()
  }
}

</script>

<style scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>
